<template>
    <div class="payment_method">
        <!-- Name -->
        <div class="form__group" :class="{ 'form__group--error' : nameError }">
            <label for="holder_name" class="form__label">Full name</label>

            <input id="holder_name" type="text" placeholder="Jane Doe" class="form__input" v-model="name">

            <p v-if="nameError" class="form__help form__help--error">{{ nameError }}</p>
        </div>
        <!-- Card -->
        <div class="form__group" :class="{ 'form__group--error' : cardError }">
            <label for="card-element" class="form__label">Card</label>

            <div ref="card" id="card-element" class="form__input"></div>

            <p v-if="cardError" class="form__help form__help--error">{{ cardError }}</p>
        </div>

    </div>
</template>
<script>
/* global Stripe, app */

export default {
    data () {
        return {
            name: '',
            stripe: null,
            nameError: null,
            cardError: null,
            paymentIntent: null
        }
    },

    mounted () {
        this.$store.dispatch('tenant/setupPaymentIntent').then((response) => {
            this.stripe = Stripe(app.config.STRIPE_KEY)
            this.paymentIntent = response.data

            const elements = this.stripe.elements({
                fonts: [
                    {
                        cssSrc: 'https://skybase.it/fonts/CircularStd-Book.otf'
                    }
                ]
            })

            this.cardElement = elements.create('card', {
                style: {
                    base: {
                        fontFamily: "'Circular Std', helvetica neue, helvetica, sans-serif",
                        fontWeight: 400,
                        fontSize: '14px',
                        '::placeholder': {
                            color: '#99A2AC'
                        }
                    }
                }
            })

            this.cardElement.mount('#card-element')
        })
    },

    methods: {
        showError (error) {
            if (error.code === 'parameter_invalid_empty' && error.param === 'payment_method_data[billing_details][name]') {
                this.nameError = 'Please provide your name'
                this.cardError = ''
            } else {
                this.nameError = ''
                this.cardError = error.message
            }
        },

        async setup (callback) {
            const { setupIntent, error } = await this.stripe.handleCardSetup(
                this.paymentIntent.client_secret, this.cardElement, {
                    payment_method_data: {
                        billing_details: { name: this.name }
                    }
                }
            )

            if (error) {
                this.showError(error)
            } else {
                callback(setupIntent)
            }
        }
    }
}
</script>
